export const checksTableUrlKey = 'security-compliances-checks';
export const resourcesTableId = 'security-compliances-resources';
